export const LOCAL = 'local';
export const DEVELOPMENT = 'development';
export const QA = 'qa';
export const PRODUCTION = 'production';
